import { AnalyticsBrowser } from '@segment/analytics-next'
import { env } from './EnvironmentVariables'
import { UserProfile } from '../UserContext'

export const AnalyticsEvents = {
    USER_LOGGED_IN: 'USER_LOGGED_IN',
    USER_LOGGED_OUT: 'USER_LOGGED_OUT',
    SESSION_CREATED: 'SESSION_CREATED',
    HOST_REJOINED: 'HOST_REJOINED',
    PEER_JOINED: 'PEER_JOINED',
    PEER_LEFT: 'PEER_LEFT',
    PEER_REMOVED: 'PEER_REMOVED',
    HOST_ENDED_SESSION: 'HOST_ENDED_SESSION',
    REFRESHED_DEVICE_LIST: 'REFRESHED_DEVICE_LIST',
    CLICKED_START_SESSION_BUTTON: 'CLICKED_START_SESSION_BUTTON',
    CLICKED_HOST_SESSION_BUTTON: 'CLICKED_HOST_SESSION_BUTTON',
    CLICKED_SCHEDULE_SESSION_BUTTON: 'CLICKED_SCHEDULE_SESSION_BUTTON',
    CLICKED_COMMUNITY_BUTTON: 'CLICKED_COMMUNITY_BUTTON',
    CLICKED_UNIMPLEMENTED: 'CLICKED_UNIMPLEMENTED',
    CLICKED_OVERVIEW_SETTINGS_BUTTON: 'CLICKED_OVERVIEW_SETTINGS_BUTTON',
    CLICKED_SESSION_SETTINGS_BUTTON: 'CLICKED_SESSION_SETTINGS_BUTTON',
    CLICKED_CAMERA_TOGGLE_BUTTON: 'CLICKED_CAMERA_TOGGLE_BUTTON',
    CLICKED_SHARE_SCREEN_BUTTON: 'CLICKED_SHARE_SCREEN_BUTTON',
    CLICKED_COLLABORATORS_BUTTON: 'CLICKED_COLLABORATORS_BUTTON',
    CLICKED_INVITE_COLLABORATORS_BUTTON: 'CLICKED_INVITE_COLLABORATORS_BUTTON',
    CLICKED_RECORD_SCREEN_BUTTON: 'CLICKED_RECORD_SCREEN_BUTTON',
    CLICKED_LEAVE_SESSION_BUTTON: 'CLICKED_LEAVE_SESSION_BUTTON',
    CLICKED_END_SESSION_BUTTON: 'CLICKED_END_SESSION_BUTTON',
    CLICKED_CHAT_BUTTON: 'CLICKED_CHAT_BUTTON',
    CLICKED_SHARE_MIDI_BUTTON: 'CLICKED_SHARE_MIDI_BUTTON',
    CLICKED_START_RECORDING_BUTTON: 'CLICKED_START_RECORDING_BUTTON',
    CLICKED_START_RECORD_DEVICE_BUTTON: 'CLICKED_START_RECORD_DEVICE_BUTTON',
    CLICKED_STOP_RECORD_DEVICE_BUTTON: 'CLICKED_STOP_RECORD_DEVICE_BUTTON',
    CLICKED_MUTE_REMOTE_MIDI_BUTTON: 'CLICKED_MUTE_REMOTE_MIDI_BUTTON',
    CLICKED_UNMUTE_REMOTE_MIDI_BUTTON: 'CLICKED_UNMUTE_REMOTE_MIDI_BUTTON',
    CLICKED_STOP_RECORDING_BUTTON: 'CLICKED_STOP_RECORDING_BUTTON',
    CLICKED_START_SCREEN_RECORDING_BUTTON: 'CLICKED_START_SCREEN_RECORDING_BUTTON',
    CLICKED_STOP_SCREEN_RECORDING_BUTTON: 'CLICKED_STOP_SCREEN_RECORDING_BUTTON',
    CLICKED_SCREEN_SHARE_SELECTION_BUTTON: 'CLICKED_SCREEN_SHARE_SELECTION_BUTTON',
    CLICKED_SHARE_COMPUTER_AUDIO_BUTTON: 'CLICKED_SHARE_COMPUTER_AUDIO_BUTTON',
    CLICKED_SHARE_SCREEN_CONFIRM_BUTTON: 'CLICKED_SHARE_SCREEN_CONFIRM_BUTTON',
    CLICKED_ENABLE_MIDI_BUTTON: 'CLICKED_ENABLE_MIDI_BUTTON',
    CLICKED_MUTE_AUDIO_TOGGLE_BUTTON: 'CLICKED_MUTE_AUDIO_TOGGLE_BUTTON',
    CLICKED_AUTO_MUTE_AUDIO_TOGGLE_BUTTON: 'CLICKED_AUTO_MUTE_AUDIO_TOGGLE_BUTTON',
    CLICKED_TALKBACK_TOGGLE_BUTTON: 'CLICKED_TALKBACK_TOGGLE_BUTTON',
    CLICKED_REMOVE_CHANNEL_BUTTON: 'CLICKED_REMOVE_CHANNEL_BUTTON',
    CLICKED_PEER_SOLO_AUDIO_TOGGLE_BUTTON: 'CLICKED_PEER_SOLO_AUDIO_TOGGLE_BUTTON',
    CLICKED_PEER_MUTE_AUDIO_TOGGLE_BUTTON: 'CLICKED_PEER_MUTE_AUDIO_TOGGLE_BUTTON',
    CLICKED_UPGRADE_BUTTON: 'CLICKED_UPGRADE_BUTTON',
    CLICKED_TAKE_SURVEY_BUTTON: 'CLICKED_TAKE_SURVEY_BUTTON',
    CLICKED_SESSION_HISTORY_BUTTON: 'CLICKED_SESSION_HISTORY_BUTTON',
    CLICKED_BOOST_SESSION_BUTTON: 'CLICKED_BOOST_SESSION_BUTTON',
    CLICKED_BOOST_SESSION_INFO_BUTTON: 'CLICKED_BOOST_SESSION_INFO_BUTTON',
    CLICKED_LEARN_MORE_BOOST_BUTTON: 'CLICKED_LEARN_MORE_BOOST_BUTTON',
    CLICKED_CREATE_ACCOUNT_BUTTON: 'CLICKED_CREATE_ACCOUNT_BUTTON',
    SENT_CHAT_MESSAGE: 'SENT_CHAT_MESSAGE',
    CHANGED_SCREEN_SELECTION: 'CHANGED_SCREEN_SELECTION',
    CHANGED_QUALITY_SELECTION: 'CHANGED_QUALITY_SELECTION',
    CHANGED_FPS_SELECTION: 'CHANGED_FPS_SELECTION',
    CLICKED_OK_BUTTON: 'CLICKED_OK_BUTTON',
    INVITE_ACCEPTED: 'INVITE_ACCEPTED',
    INVITE_REJECTED: 'INVITE_REJECTED',
    INVITE_SENT: 'INVITE_SENT',
    JOINED_RECENT_SESSION: 'JOINED_RECENT_SESSION',
    JOINED_WITH_ROOM_CODE: 'JOINED_WITH_ROOM_CODE',
    JOINED_UPCOMING_SESSION: 'JOINED_UPCOMING_SESSION',
    JOINED_WITH_ROOM_LINK: 'JOINED_WITH_ROOM_LINK',
    JOINED_ROOM_WITH_PASSWORD: 'JOINED_ROOM_WITH_PASSWORD',
    VIEWED_UPGRADE_PAGE: 'VIEWED_UPGRADE_PAGE',
    CLICKED_FEATURE_WAITLIST_BUTTON: 'CLICKED_FEATURE_WAITLIST_BUTTON',
    UPGRADE_TO_MUSE_PRO_POPUP_TRIGGERED: 'UPGRADE_TO_MUSE_PRO_POPUP_TRIGGERED',
    BOOSTED_ROOM: 'BOOSTED_ROOM',
    UPDATED_MICROPHONE: 'UPDATED_MICROPHONE',
    UPDATED_SPEAKER: 'UPDATED_SPEAKER',
    UPDATED_CAMERA: 'UPDATED_CAMERA',
    AUDIO_INPUT_TOGGLED: 'AUDIO_INPUT_TOGGLED',
    CHANNEL_GROUP_ADDED: 'CHANNEL_GROUP_ADDED',
    CHANNEL_GROUP_REMOVED: 'CHANNEL_GROUP_REMOVED',
    CHANNEL_GROUP_REPLACED: 'CHANNEL_GROUP_REPLACED',
    AUDIO_QUALITY_CHANGED: 'AUDIO_QUALITY_CHANGED',
    DESKTOP_CONTROL_PERMISSION_REQUESTED: 'DESKTOP_CONTROL_PERMISSION_REQUESTED',
    DESKTOP_CONTROL_PERMISSION_GRANTED: 'DESKTOP_CONTROL_PERMISSION_GRANTED',
    DESKTOP_CONTROL_PERMISSION_DENIED: 'DESKTOP_CONTROL_PERMISSION_DENIED',
    VIRTUAL_BACKGROUND_MODAL_OPENED: 'VIRTUAL_BACKGROUND_MODAL_OPENED',
    VIRTUAL_BACKGROUND_DISABLED: 'VIRTUAL_BACKGROUND_DISABLED',
    VIRTUAL_BACKGROUND_PREVIEW_CHANGED: 'VIRTUAL_BACKGROUND_PREVIEW_CHANGED',
    VIRTUAL_BACKGROUND_SELECTED: 'VIRTUAL_BACKGROUND_SELECTED',
    CLICKED_REMOVE_USER_BUTTON: 'CLICKED_REMOVE_USER_BUTTON',
    CLICKED_STOP_SCREEN_CONTROL_BUTTON: 'CLICKED_STOP_SCREEN_CONTROL_BUTTON',
    CLICKED_PIN_VIDEO_BUTTON: 'CLICKED_PIN_VIDEO_BUTTON',
    CLICKED_UNPIN_VIDEO_BUTTON: 'CLICKED_UNPIN_VIDEO_BUTTON',
    CLICKED_MY_VIDEO_SETTINGS_BUTTON: 'CLICKED_MY_VIDEO_SETTINGS_BUTTON',
    CLICKED_MY_SCREENSHARE_SETTINGS_BUTTON: 'CLICKED_MY_SCREENSHARE_SETTINGS_BUTTON',
    CLICKED_MANAGE_COLLABORATORS_BUTTON: 'CLICKED_MANAGE_COLLABORATORS_BUTTON',
    CLICKED_STOP_MY_VIDEO_BUTTON: 'CLICKED_STOP_MY_VIDEO_BUTTON',
    CLICKED_REQUEST_SCREEN_CONTROL_BUTTON: 'CLICKED_REQUEST_SCREEN_CONTROL_BUTTON',
    DELETED_CHAT_MESSAGE: 'DELETED_CHAT_MESSAGE',
    ATTACHED_CHAT_FILE: 'ATTACHED_CHAT_FILE',
    SWITCHED_CHAT_TAB: 'SWITCHED_CHAT_TAB',
    DOWNLOADED_CHAT_FILE: 'DOWNLOADED_CHAT_FILE',
    DELETED_CHAT_FILE: 'DELETED_CHAT_FILE',
    CANCELED_CHAT_FILE_DOWNLOAD: 'CANCELED_CHAT_FILE_DOWNLOAD',
    CHANGED_TALKBACK_KEY_MODE: 'CHANGED_TALKBACK_KEY_MODE',
    CHANGED_AUTO_MUTE_THRESHOLD: 'CHANGED_AUTO_MUTE_THRESHOLD',
    CHANGED_AUTO_MUTE_ATTACK: 'CHANGED_AUTO_MUTE_ATTACK',
    CHANGED_AUTO_MUTE_RELEASE: 'CHANGED_AUTO_MUTE_RELEASE',
    TOGGLED_SHOW_ALL_AUDIO_DEVICES: 'TOGGLED_SHOW_ALL_AUDIO_DEVICES',
    TOGGLED_DISABLE_DEVICE_CHANGE_PROMPTS: 'TOGGLED_DISABLE_DEVICE_CHANGE_PROMPTS',
    TOGGLED_SELECT_SYSTEM_DEFAULT_OUTPUT_ON_STARTUP: 'TOGGLED_SELECT_SYSTEM_DEFAULT_OUTPUT_ON_STARTUP',
    TOGGLED_PREVENT_VOLUME_AUTO_ADJUSTMENT: 'TOGGLED_PREVENT_VOLUME_AUTO_ADJUSTMENT',
    TOGGLED_DISABLE_REMOTE_RECORDING: 'TOGGLED_DISABLE_REMOTE_RECORDING',
    TOGGLED_ONLY_RECORD_SESSION_AUDIO: 'TOGGLED_ONLY_RECORD_SESSION_AUDIO',
    TOGGLED_SHOW_MUSE_IN_SCREEN_RECORDING: 'TOGGLED_SHOW_MUSE_IN_SCREEN_RECORDING',
    CHANGED_SCREEN_TO_RECORD: 'CHANGED_SCREEN_TO_RECORD',
    CLICKED_JOIN_BREAKOUT_SESSION: 'CLICKED_JOIN_BREAKOUT_SESSION',
    CLICKED_CREATE_BREAKOUT_SESSION: 'CLICKED_CREATE_BREAKOUT_SESSION',
    CLICKED_JOIN_MAIN_ROOM_SESSION: 'CLICKED_JOIN_MAIN_ROOM_SESSION',
    CLICKED_EXIT_FULLSCREEN: 'CLICKED_EXIT_FULLSCREEN',
    CLICKED_ENTER_FULLSCREEN: 'CLICKED_ENTER_FULLSCREEN',
} as const

export type AnalyticsEventType = keyof typeof AnalyticsEvents

let analyticsInstance: ReturnType<typeof AnalyticsBrowser.load> | null = null

const getAnalyticsInstance = (): ReturnType<typeof AnalyticsBrowser.load> | undefined => {
    try {
        if (!analyticsInstance) {
            const ANALYTICS_WRITE_KEY = env.ANALYTICS_WRITE_KEY || ''
            if (!ANALYTICS_WRITE_KEY) {
                throw new Error('ANALYTICS_WRITE_KEY is not defined')
            }

            analyticsInstance = AnalyticsBrowser.load({
                writeKey: ANALYTICS_WRITE_KEY,
            })
        }
        return analyticsInstance
    } catch (error) {
        console.error('Failed to load analytics instance:', error)
    }
    return undefined // Ensure a return value in case of error
}

export const setAnalyticsIdentity = (userUrn: string, profile: UserProfile) => {
    const Analytics = env.ANALYTICS_WRITE_KEY ? getAnalyticsInstance() : undefined

    if (Analytics) {
        Analytics.identify(userUrn, { ...profile })
    } else {
        console.error('Analytics instance is not available')
    }
}

export const trackPageVisit = (page: string) => {
    const Analytics = env.ANALYTICS_WRITE_KEY ? getAnalyticsInstance() : undefined

    if (Analytics) {
        Analytics.page(page)
    } else {
        console.error('Analytics instance is not available')
    }
}

export const logUserActivity = (
    event: AnalyticsEventType,
    username: string,
    sessionId: string,
    additionalData: Record<string, any> = {}
) => {
    const Analytics = env.ANALYTICS_WRITE_KEY ? getAnalyticsInstance() : undefined

    if (Analytics) {
        Analytics.track(event, {
            username: username,
            sessionId,
            ...additionalData,
        })
    } else {
        console.error('Analytics instance is not available')
    }
}
